<template>
	<el-popover
		placement="bottom"
		width="320"
		v-model="visible">
		<div style="font-size: 12px;text-indent: 12px;margin-bottom: 4px;color: #888">将需要包含的内容复制到以下输入框，点击确定。支持多行数据及空格分隔数据。</div>
		<el-input type="textarea" :rows="10" v-model="text"></el-input>
		<div class="t_footer" style="text-align: center;margin: 8px 0;">
			<link-button type="line" @click="visible=!visible">取消</link-button>
			<link-button style="margin-left: 8px" @click="save">确定</link-button>
		</div>
		<i class="el-icon-document" style="cursor: pointer" slot="reference"></i>
	</el-popover>
</template>

<script>
    export default {
        name: "multi-text-adder",
		props: {value: String},
		data(){
        	return{
        		text: '',
				visible: false
			}
		},
		watch: {
			visible(val){
				if(!val) return;
				let v = this.value;
				v = v.replace(/，/g, ',');
				this.text = typeof v !== 'string' ? '' : v.replace(/,/g, '\n');
			}
		},
		methods: {
			save(){
				let v = this.text.replace(/\s+/g, ',');
				this.visible = false;
				this.$nextTick(()=> this.$emit('input', v))
			}
		}
    }
</script>

<style scoped>
</style>
